const ROI_DISMISSED_PREFIX = 'onboarding-roi-dismissed-'

export function isOnboardingRoiDismissed(stepKey: string): boolean {
  try {
    return localStorage.getItem(`${ROI_DISMISSED_PREFIX}${stepKey}`) === '1'
  } catch {
    return false
  }
}

export function dismissOnboardingRoi(stepKey: string) {
  try {
    localStorage.setItem(`${ROI_DISMISSED_PREFIX}${stepKey}`, '1')
  } catch {
    // ignore
  }
}

const COMPLETION_AT_KEY = 'onboarding-completed-at'
const CELEBRATION_SHOWN_PREFIX = 'onboarding-celebration-shown-'

export function markOnboardingCompletedAt() {
  try {
    localStorage.setItem(COMPLETION_AT_KEY, String(Date.now()))
  } catch {
    // ignore
  }
}

export function hasOnboardingCelebrationBeenShown(userId: number): boolean {
  try {
    return localStorage.getItem(`${CELEBRATION_SHOWN_PREFIX}${userId}`) === '1'
  } catch {
    return false
  }
}

export function markOnboardingCelebrationShown(userId: number) {
  try {
    localStorage.setItem(`${CELEBRATION_SHOWN_PREFIX}${userId}`, '1')
  } catch {
    // ignore
  }
}

export function clearOnboardingCelebrationShown(userId: number) {
  try {
    localStorage.removeItem(`${CELEBRATION_SHOWN_PREFIX}${userId}`)
    localStorage.removeItem(COMPLETION_AT_KEY)
  } catch {
    // ignore
  }
}

export function onboardingCompletionBonusDeadlineMs(): number | null {
  try {
    const raw = localStorage.getItem(COMPLETION_AT_KEY)
    if (!raw) return null
    const completedAt = Number.parseInt(raw, 10)
    if (!Number.isFinite(completedAt)) return null
    const deadline = completedAt + 48 * 60 * 60 * 1000
    return deadline > Date.now() ? deadline : null
  } catch {
    return null
  }
}
